import React            from "react";
import { useTranslate } from "../../../../hooks/use";

const Hero = () => {
  const t  = useTranslate();

  return (
    <div className="landing-container-wrapper">
      <div className="img-header"></div>
      <div className="header-desc">
        <h1>
          {t('Static_Label_Demirkan')}<br />
          <span>{t('Static_Label_Consultancy')}</span>
        </h1>
        <p>
          Boost your app’s capabilities without worrying about scalability and
          stability. Boost your app’s capabilities without worrying about scalability and
          stability.
        </p>
      </div>
    </div>
  );
};

export default Hero;
